<template>
  <div class="pieChart">
    <div v-show="defaultData.seriesData.length || isShow || !showNoTips" ref="dom" :style="{height: height}"></div>
    <!-- <div v-show="!defaultData.seriesData.length || !isShow"><div class="nodata"></div> </div> -->
    <AppNoData v-show="showNoTips && !defaultData.seriesData.length && !isShow" :height="Number(height.replace('px',''))">暂无信息</AppNoData>
  </div>
</template>
<script>
  import echarts from 'echarts'
  import {on, off} from '@/utils/tools'

  export default {
    name: 'FlowPie',
    data() {
      return {
        dom: null,
        defaultData: {
          colorList: ['#1e90ff', '#e96908', '#FF6507', '#ff9966', '#ff99cc', '#00cc33', '#006ecc', '#e6f04c', '#fe2b53', '#881584'],
          legendData: [], // 图例数组
          radius: [0, 70], 
          center: ['50%', '41%'],
          labelShow: false,  // 是否显示标线
          minLabelLen: 0,  // 标签名字长度超过多少字换行
          seriesName: '',
          seriesData: [ // 对应数据
            // {value: 500, name: 'APP'},
            // {value: 200, name: '小程序'},
            // {value: 300, name: '其他'}
          ],
          roseType: 'radius',
          valueFormat: '', //要展示label格式
          length: 4,
          length2: 4,
          labelColor: undefined,
          isOverflowHide: true, // 如果饼图的label太长（超过overflowWords个字）且 legend太多（超过overLegends个），此时isOverflowHide为true的话,无论labelShow是否为true，都隐藏label
          overflowWords: 11,
          overLegends: 8,
        },
        isShow: true,
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.initPie()
      })
    },
    props: {
      showNoTips: {
        type: Boolean,
        default: true
      },
      // 可传值覆盖初始设置，如有图表外形上修改
      height: {
        type: String,
        default: '200px'
      },
      pieOptions: {
        type: Object,
        default: () => {
        }
      },
      // 传值设置部分值，图表外形不变，只设置不同展示值
      setSomeOptions: {
        type: Object,
        default: () => {
        }
      }
    },
    methods: {
      countLabelNums(legendData){
        let flag = false;
        legendData.map(val => {
          if(val.length >= this.defaultData.overflowWords){
            flag = true;
          }
        });
        return flag;
      },
      initPie() {
        this.isShow = true;
        this.$utils.deepAssign(this.defaultData, this.setSomeOptions)
        let flag = false;
        _(this.defaultData.seriesData).forEach(value => {
          if(value.value){
            flag = true;
          }
        });
        if(!flag){
          this.isShow = false;
        }
        let legendData = this.defaultData.legendData;
        if(this.defaultData.isOverflowHide && legendData.length >= this.defaultData.overLegends && this.countLabelNums(legendData)){
          this.$set(this.defaultData,'labelShow',false);
        }
        let option = {
          tooltip: { // 鼠标hover覆盖提示框
            show: true, // 可视
            trigger: 'item', // 根据item提示信息
            // formatter: "{a} <br/>{b}: {c} ({d}%)" //提示内容
            formatter: '{b}: {d}%' // 提示内容
          },
          legend: {
            // orient: 'vertical', //竖直放置
            icon: 'circle',//图标为圆形，默认是方形
            // align:'auto',
            // itemGap: 6 ,//两个属性的距离
            // itemWidth: 8,//图标的宽度，对应有itemHeight为高度,圆形只有半径
            // x: '0%',//距离左侧位置
            // y: '30%', //距离上面位置
            itemWidth: 8, // 设置宽度
            itemHeight: 8, // 设置高度
            bottom: 0,
            data: this.defaultData.legendData,
            align: 'left', // 图标与属性名的相对位置，默认为right，即属性名在左，图标在右
            // left:center,
            selectedMode: true, // 可选择
            formatter: function (v) {
              return v
            },
            textStyle: {// 属性名的字体样式设置
              fontSize: 10,
              color: '#666'
            }
          },
          // calculable : true,
          series: [ // 饼状图设置
            {
              name: this.defaultData.seriesName, // 设置名称，跟数据无相关性
              type: 'pie', // 类型为饼状
              radius: this.defaultData.radius, // 内圈半径，外圈半径
              center: this.defaultData.center, // 饼状图位置，第一个参数是左右，第二个是上下。
              avoidLabelOverlap: true,
              stillShowZeroSum: false,
              startAngle: 240,
              roseType: this.defaultData.roseType,
              // selectedMode: 'single',
              hoverAnimation: false, // 鼠标悬停效果，默认是true
              label: { // 设置饼状图圆心属性
                normal: {
                  // rotate: 10,
                  show: this.defaultData.labelShow,
                  color: this.defaultData.labelColor,
                  // position: 'center'
                  formatter: (v) => {
                    let minLen = this.defaultData.minLabelLen;
                    if(minLen){
                      let text = v.name;
                      let percent = v.percent;
                      if(minLen == 'showAll'){
                        return `${text}\n${percent}%`;
                      }else{
                        let len = this.defaultData.minLabelLen;
                        return text.length <= len 
                            ? `${text}\n${percent}%`
                            : `${text.slice(0,len)}...\n${percent}%`
                      }
                    }else{
                      return `${this.defaultData.valueFormat}${ this.$utils.formatMoney(v.value,0)}`;
                    }
                  }
                },
              },
              labelLine: {
                normal: {
                  show: this.defaultData.labelShow,
                  // smooth: true,
                  // rotate: 10,
                  length: this.defaultData.length,
                  length2: this.defaultData.length2,
                  lineStyle:{
                    type: 'dashed',
                  }
                },
                emphasis:{
                  show: this.defaultData.labelShow,
                  lineStyle: {
                    type: 'dashed'
                  }
                }
              },
              data: this.defaultData.seriesData,
              itemStyle: { // 元素样式
                normal: {
                  // 柱状图颜色
                  color: (params) => { // 对每个颜色赋值
                    // 颜色列表
                    var colorList = this.defaultData.colorList
                    // 返回颜色
                    return colorList[params.dataIndex]
                    
                  },
                },
                emphasis: {
                  borderWidth: 4, // 鼠标悬浮，有白色间隙
                  borderColor: 'transparent',
                  label:{
                    show: this.defaultData.labelShow,
                  },
                }
              },
            }
          ]
        }
        this.$utils.deepAssign(option, this.pieOptions)
        this.dom = echarts.init(this.$refs.dom)
        this.dom.clear()
        this.dom.setOption(option) // 使用刚指定的配置项和数据显示图表。
        on(window, 'resize', this.resize)
      }
    },
    watch: {
      setSomeOptions() {
        this.initPie()
      },
      pieOptions() {
        this.initPie()
      }
    },
    beforeDestroy() {
      off(window, 'resize', this.resize)
    }
  }
</script>
<style lang="scss" scoped>
  .pieChart{
    position: relative;
    width:100%;
    height:100%;
    text-align:center;
    .nodata{
      position: absolute;
      /* background: url(../../../assets/images/1.png) 50% 50% no-repeat; */
      /* background-size: auto 90%; */
      width: 140px;
      height: 166px;
      // border-radius: 50%;
      // line-height: 140px;
      text-align: center;
      // border: 2px solid #2062E6;
      left:50%;
      top:50%;
      transform: translate(-50%,-50%);
      // margin-left:-70px;
      // margin-top:-70px;
    }
  }
</style>
